import type {AppLocale} from './locales'

const ENGLISH_PRIMARY = new Set('US,GB,IE,AU,NZ,CA,ZA'.split(','))
const DACH = new Set('DE,AT,CH,LI'.split(','))

const COUNTRY_TO_LOCALE: Record<string, AppLocale> = {
  BG: 'bg',
  TR: 'tr',
  SE: 'sv',
}

DACH.forEach((cc) => {
  COUNTRY_TO_LOCALE[cc] = 'de'
})
ENGLISH_PRIMARY.forEach((cc) => {
  COUNTRY_TO_LOCALE[cc] = 'en'
})

/**
 * Maps a visitor’s ISO 3166-1 alpha-2 country code to the site locale we
 * would usually expect for that region, or `null` when the mapping is
 * uncertain (no prompt).
 */
export function appLocaleForCountryCode(
  code: string | null | undefined,
): AppLocale | null {
  if (!code) return null
  const u = String(code).trim().toUpperCase()
  if (u.length !== 2) return null
  return COUNTRY_TO_LOCALE[u] ?? null
}
